import { FeedRidContext, useCollapseMargin } from "@finbackoffice/site-core";
import { useSocketStorage } from "hooks";
import { FC, useContext } from "react";
import { ISportFeedResponse } from "@finbackoffice/websocket-client";
import LiveCategories from "components/sport/live/layouts/categories/LiveCategories";
import AdvancedSidebarSport from "../../AdvancedSidebarSport";
import styles from "./advanced-sidebar-live-sport.module.sass";

type Props = {
    sport: ISportFeedResponse;
    openedByDefault: boolean;
    disableCollapsing?: boolean;
    isSelected?: boolean;
};

const AdvancedSidebarLiveSport: FC<Props> = ({
    sport,
    openedByDefault,
    disableCollapsing,
    isSelected,
}) => {
    const { liveRid } = useContext(FeedRidContext);
    const { getCategories } = useSocketStorage(liveRid);
    const { opened, animating, headerRef, containerRef } = useCollapseMargin(openedByDefault);

    const categories = getCategories(sport.id);

    return (
        <div className={styles.liveSportItem}>
            <AdvancedSidebarSport
                ref={disableCollapsing ? undefined : headerRef}
                sport={sport}
                opened={opened}
                isSelected={isSelected}
            />
            {(opened || animating) && (
                <LiveCategories
                    categories={categories}
                    sportId={sport.id}
                    ref={containerRef}
                    showArrow={false}
                    variant="sidebar"
                />
            )}
        </div>
    );
};

export default AdvancedSidebarLiveSport;
